import { uploadVideosURL, videosURL } from "../../apiEndPoints"
import {
    fetchVideos,
    fetchResourceVideos,
} from "../../state/wellnessVideos/wellnessVideosSlice"
import { logTransaction } from "../appActions"
import { axiosGet, axiosPost } from "../../utilities/axiosRequest"

export function VideoLinks() {
    return function (dispatch, getState) {
        let userProfileid = Object.keys(getState().login.user.userProfile)[0]
        const program = getState().user.program
        let url = videosURL + `/${userProfileid}`
        url += `?programId=${program.id}`
        axiosGet(url)
            .then(response => {
                console.log(response, "nghjghjghjjkjkjj")
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(fetchVideos(response.data.responseData))
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    dispatch(fetchVideos([]))
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                dispatch(fetchVideos([]))
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function resourceLinks(linksSucess, linksFailure) {
    return function (dispatch, getState) {
        const program = getState().user.program
        let url = videosURL + `/${getState().patients.selectedPatient.userId}`
        url += `?programId=${program.id}`
        axiosGet(url)
            .then(response => {
                console.log(response, "nghj")
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(fetchResourceVideos(response.data.responseData))
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                    linksSucess && linksSucess()
                } else {
                    dispatch(fetchResourceVideos([]))
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                    linksFailure && linksFailure()
                }
            })
            .catch(err => {
                dispatch(fetchResourceVideos([]))
                dispatch(logTransaction("Fetch Performace Report Failed", err))
                linksFailure && linksFailure()
            })
    }
}

export const uploadVideo = (data, success, failure) => {
    return function (dispatch, getState) {
        let url = uploadVideosURL
        axiosPost(url, data)
            .then(response => {
                if (response.data.statusCD == 200) {
                    // dispatch(logTransaction("User Updated", response))
                    success()
                } else {
                    dispatch(logTransaction("User Updation error", response))
                    failure(response.data.statusMSG)
                }
                // dispatch(updateLoading(false));
            })
            .catch(err => {
                // dispatch(logTransaction("User Updation failure", err))
                // dispatch(updateLoading(false));
                failure("")
                // error(err);
            })
    }
}
